import AccountStatement from './AccountMonthlyStatement';
import { connect } from 'react-redux';
import { monthlyStatementActions } from 'src/store/modules/monthlyStatement';
import { contentSel } from 'src/store/modules/monthlyStatement';

const mapStateToProps = (state: any) => {
  return {
    monthlyStatementContent: contentSel(state)
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  getMonthlyStatement: (page: number, period: number, size: number) => {
    dispatch(monthlyStatementActions.getMonthlyStatement(page, period, size));
  }
});

export const pureComponent = AccountStatement;
export default connect(mapStateToProps, mapDispatchToProps)(AccountStatement);

interface IDispatchFromProps {
  getMonthlyStatement(page: number, period: number, size: number): void;
}
